import RaisedButton from 'material-ui/RaisedButton';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/cardsummary.css';
import '../../stylesheet/tabdesign.css';
// import AuthNavbar from '../navigation/authnavigation.jsx'
import AdminNavbar from '../navigation/adminnavigation.jsx';



const mapStateToProps = state =>
    ({
        useridInfoState: state.getCardNoDetailsReducer.cardDetailState,
    })
const mapDispatchToProps = dispatch =>
    ({
        getCardNoDetails(cardNo) {
            dispatch(
                actions.getCardNoDetailsAction(cardNo)
            )
        },
        getCardDetails(cardRefNo) {
            dispatch(
                actions.getCardDetailAction(cardRefNo)
            )
        },
    })



class CardNoDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userid: ''
        }


    }
    // static getDerivedStateFromProps(nextProps, prevState){
 
    //     if(nextProps.cardDetailState!==prevState.cardDetailState){
    //       return { cardDetailState: nextProps.cardDetailState};
    //    }
    //     else return null;
    //  }

    //  componentDidUpdate(prevProps, prevState) {
    //     if(prevProps.cardDetailState!==this.state.cardDetailState){
    //       //Perform some operation here
    //       this.setState({cardDetailState: cardDetailState});
    //     }
    //   }

    componentDidMount() {
        // let user = localStorage.getItem('ec')
        // var bytes = CryptoJS.AES.decrypt(user.toString(), 'gmcabs123')
        // var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        // this.setState({ param: plaintext })
        // this.props.getCardNoDetails(user)

    }

    handleSelect(cardReferenceId) {
        let _this = this
        localStorage.setItem('cardRefNumber', cardReferenceId)
        localStorage.setItem('cardSearchToast', 'first')
        this.props.getCardDetails(cardReferenceId)
        setTimeout(function () {
            if (localStorage.getItem('cardSearchToast') === 'second') {
                _this.props.history.push('/carddetails')
            }
        }, 3000)
    }

    render() {
        // const height = $(window).height() - 110;
        const { useridInfoState } = this.props
        return (
            <div>
                <div className="col-sm-12">
                    <AdminNavbar />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12" style={{ marginTop: "100px" }}>
                    <span style={{ fontSize: "25px", fontWeight: "400" }}>
                        User Results
                    </span>
                </div>
                <div className="col-sm-11" style={{ marginLeft: "20px", marginTop: "20px" }}>
                    <div className="col-sm-12" style={{ padding: "0px" }}>
                        <div className="row">
                            {(useridInfoState && useridInfoState.status === 200) ?
                                //map array
                                    (<div className="col-sm-4">

                                        <div className="col-sm-12" >
                                            <div class="container">
                                                <div class="row">
                                                    <table className="table table-active table-striped " style={{ marginLeft: "20px",height:"20rem !important", marginTop: "15px",  }}>
                                                        <thead className="thead-dark">
                                                            <tr style={{ fontSize: "11px" }}>
                                                                <th scope="col" colspan="2" style={{ padding: "10px", textAlign: "center", fontSize: "15px" }}>Cardholder Information</th>

                                                            </tr>
                                                        </thead>

                                                        <tbody id="myTable" style={{ fontSize: "15px" }}>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>User ID:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.userName}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Number:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.cardNumber}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Ref. Number:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.cardReferenceId}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Status:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px",wordWrap:" break-word", }}> {useridInfoState.body.portalCardStatus}</td>
                                                          

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Status at Processor:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.cardStatus}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Name:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.firstName} {useridInfoState.body.lastName}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Date of Birth:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.dateofbirth}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.address} {useridInfoState.body.address2}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>City:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.city}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>State:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.state}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Zip/Post Code:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.pincode}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Country:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.country}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Secret Question:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.secretQuestion}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Answer:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.secretAnswer}</td>

                                                            </tr>
                                                            {/* <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Home Phone Number:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.homePhoneNumber}</td>

                                                            </tr> */}
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Mobile Number:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.mobileNumber}</td>

                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>E-mail:</td>
                                                                <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {useridInfoState.body.emailId}</td>

                                                            </tr>

                                                        </tbody>


                                                    </table>
                                                </div>
                                                <div className=" offset-5 col-sm-7" style={{marginBottom:"15px"}}>
                                                    <RaisedButton
                                                        label="Select"
                                                        // buttonStyle={styles.buttonStyle}
                                                        // labelColor="#fff"
                                                        backgroundColor="#333"
                                                        labelColor="#fff"
                                                        onClick={() => { this.handleSelect(useridInfoState.body.cardReferenceId) }}
                                                        disabled={this.state.disabled}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                <div></div>
                            }
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardNoDetails);


// WEBPACK FOOTER //
// ./src/components/adminuser/cardnodetails.jsx